import React from "react";
import PropTypes from "prop-types";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";

import {
  defaultPasscodeTheme,
  switchControl,
  textfield,
  selectField,
  getSelectedValueTranslated,
  getSelectValues,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";
import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";

import {
  CONFERENCE_PARTY_ALERT_ACTION,
  CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT,
  PREPAID_FLAG,
  CONFERENCE_PARTY_ALERT_TIMER,
  CONFERENCE_PARTY_ACTION_TIMER,
  PREPAID_SECONDS,
  CONFERENCE_PARTY_ALERT_ALLOW_RESET,
  CONFERENCE_PARTY_ALERT_THRESHOLD,
} from "../../../utils/responseValue";

const useStyles = makeStyles(theme => ({
  ...defaultPasscodeTheme(theme),
}));

const PMPrepaidAndAlert = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleTextChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.value });
  };
  const handleSwitchChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.checked });
  };
  const handleSelectChange = name => event => {
    setConfRestRep({
      ...confRestRep,
      [name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = theme => ({
    formControl: {
      width: "200px",
    },
  });

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <div className={classes.centerer}>
        {selectField(
          customStyle,
          translate[CONFERENCE_PARTY_ALERT_ACTION],
          getSelectValues(selectValues, CONFERENCE_PARTY_ALERT_ACTION),
          getSelectedValueTranslated(
            confRestRep[CONFERENCE_PARTY_ALERT_ACTION],
            selectValues,
            CONFERENCE_PARTY_ALERT_ACTION
          ),
          handleSelectChange(CONFERENCE_PARTY_ALERT_ACTION)
        )}
        {selectField(
          customStyle,
          translate[CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT],
          getSelectValues(selectValues, CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT),
          getSelectedValueTranslated(
            confRestRep[CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT],
            selectValues,
            CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT
          ),
          handleSelectChange(CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT)
        )}
        {selectField(
          customStyle,
          translate[PREPAID_FLAG],
          getSelectValues(selectValues, PREPAID_FLAG),
          getSelectedValueTranslated(confRestRep[PREPAID_FLAG], selectValues, PREPAID_FLAG),
          handleSelectChange(PREPAID_FLAG)
        )}
      </div>
      <div className={classes.lineBreak} />
      {textfield(
        classes,
        isDesktop,
        confRestRep[CONFERENCE_PARTY_ALERT_THRESHOLD],
        translate[CONFERENCE_PARTY_ALERT_THRESHOLD],
        handleTextChange(CONFERENCE_PARTY_ALERT_THRESHOLD)
      )}
      {textfield(
        classes,
        isDesktop,
        confRestRep[CONFERENCE_PARTY_ALERT_TIMER],
        translate[CONFERENCE_PARTY_ALERT_TIMER],
        handleTextChange(CONFERENCE_PARTY_ALERT_TIMER)
      )}
      <div className={classes.lineBreak} />
      {textfield(
        classes,
        isDesktop,
        confRestRep[CONFERENCE_PARTY_ACTION_TIMER],
        translate[CONFERENCE_PARTY_ACTION_TIMER],
        handleTextChange(CONFERENCE_PARTY_ACTION_TIMER)
      )}
      {textfield(
        classes,
        isDesktop,
        confRestRep[PREPAID_SECONDS],
        translate[PREPAID_SECONDS],
        handleTextChange(PREPAID_SECONDS)
      )}
      <div className={classes.lineBreak} />
      {switchControl(
        classes,
        confRestRep[CONFERENCE_PARTY_ALERT_ALLOW_RESET],
        CONFERENCE_PARTY_ALERT_ALLOW_RESET,
        translate[CONFERENCE_PARTY_ALERT_ALLOW_RESET],
        handleSwitchChange(CONFERENCE_PARTY_ALERT_ALLOW_RESET)
      )}
      <div className={classes.lineBreak} />
    </form>
  );
};

PMPrepaidAndAlert.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMPrepaidAndAlert;
